@if (roleService.can('read', 'admin') | async) {
  <mat-card >
    <mat-card-header>
      <div mat-card-avatar><i class="fa fa-users fa-2x"></i></div>
      <mat-card-title>{{ 'warehouse' | human: null: null: 'plural' }}</mat-card-title>
      <mat-card-subtitle>Administre la información de las {{'warehouse_plural' | human | lowercase}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <ngx-crud-manager [service]="warehouseService" [itemTemplate]="itemTemplate" [formTemplate]="formTemplate" [formGroup]="warehouseForm">
        <ng-template #itemTemplate let-item>
          {{item.name}}
        </ng-template>
        <ng-template #formTemplate let-fform="form" let-value="value">
          <form [formGroup]="fform">
            <mat-form-field>
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name" autocomplete="off" required>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Dirección</mat-label>
              <input matInput formControlName="address" autocomplete="off" required>
            </mat-form-field>
            </form>
          </ng-template>
      </ngx-crud-manager>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <div mat-card-avatar><i class="fa fa-user-plus fa-2x"></i></div>
      <mat-card-title>{{companyService.getText('location') || 'Local'}}(s)</mat-card-title>
      <mat-card-subtitle>Administre cada {{companyService.getText('location') || 'Local'}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <ngx-crud-manager
        [formTemplate]="role"
        [service]="locationService"
        [formGroup]="formGroup"
        [itemTemplate]="itemTemplate"
      >
      </ngx-crud-manager>
      <ng-template #itemTemplate let-item>
        {{item.name}}
      </ng-template>
      <ng-template #role  let-form="form" let-item="item">
        <form [formGroup]="form">
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre" formControlName="name" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Direccion</mat-label>
            <input matInput placeholder="Dirección" formControlName="address" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Bodega</mat-label>
            <mat-select formControlName="warehouse_id" autocomplete="off">
              @for (warehouse of warehouses.value(); track warehouse.id) {
                <mat-option [value]="warehouse.id">
                  {{warehouse.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </ng-template>
    </mat-card-content>
  </mat-card>

  <app-admin-brands></app-admin-brands>
}

<div class="requirements">
  <mat-card>
    <mat-card-header>
      <div mat-card-avatar><i class="fa fa-book fa-2x"></i></div>
      <mat-card-title>{{'requirement_plural' | human}}</mat-card-title>
      <mat-card-subtitle>Administra tus {{'requirement_plural' | human}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <ngx-crud-manager
        [service]="requirementsService"
        [itemTemplate]="itemTemplate"
        [formTemplate]="requirementTemplate"
        [formGroup]="requirementForm"
        [transformValueForFormFn]="prepareRequirementForForm.bind(this)"
        [transformValueForSubmitFn]="prepareRequirementForSubmit.bind(this)"
      >
      </ngx-crud-manager>
      <ng-template #requirementTemplate let-form="form" let-item="item">
        <form [formGroup]="form">
          <mat-form-field>
            <mat-label>{{'location' | human : null : null: 'plural'}}</mat-label>
            <mat-select [placeholder]="'location' | human : null : null: 'plural'" formControlName="location_ids" multiple>
              <mat-option *ngFor="let location of locations.value()" [value]="location.id">{{location.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre" formControlName="name" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Valor (Base)</mat-label>
            <input matInput type="number" placeholder="Valor (Base)" formControlName="price">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Máx. Agendamientos Diarios</mat-label>
            <input matInput type="number" placeholder="Máx. Agendamientos Diarios" formControlName="max_daily_bookings">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Duración (Minutos)</mat-label>
            <input matInput type="number" placeholder="Duración (Minutos)" formControlName="duration" step="1">
          </mat-form-field>
          <mat-form-field>
            <mat-label>
              Marcas
              <mat-icon matTooltip="Marcas disponibles al seleccionar este/a {{'requirement' | human | lowercase}}" matTooltipPosition="above">info</mat-icon>
            </mat-label>
            <mat-select multiple [(ngModel)]="selectedBrandIds" [ngModelOptions]="{standalone: true}">
              <mat-option selectAll [value]="-1">MARCAR TODOS</mat-option>
              @for (brand of brands(); track brand.id) {
                <mat-option [value]="brand.id">
                  {{ brand.name }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>Si no se selecciona ninguna marca, todas las marcas estarán disponibles para este/a {{'requirement' | human | lowercase}}</mat-hint>
          </mat-form-field>
          <br><br>
        </form>
      </ng-template>
    </mat-card-content>
  </mat-card>
  <ng-template #itemTemplate let-item>
    {{item.name}}
  </ng-template>
</div>
<app-admin-additionals></app-admin-additionals>

